export default {
  "home.eyebrow": "AllChinaBuy-ressourcehubbet",
  "home.h1": "AllChinaBuy Spreadsheet: Find produkter, sælgere og købsressourcer",
  "home.heroCopy": "Udforsk kuraterede AllChinaBuy-spreadsheetressourcer, produktfund, oplysninger om pålidelige sælgere, QC-guider, forsendelsesressourcer og praktiske købstips — alt samlet i ét letanvendeligt hub.",
  "home.trustText": "Uafhængig ressource · Opdateres jævnligt · Bygget til smartere produktresearch",

  "home.categoriesTitle": "Gennemse produktkategorier",
  "home.categoriesSubtitle": "Gå direkte til den kategori, du har brug for. Hvert link åbner hovedwebstedet med kuraterede produkter.",
  "home.dropdownLabel": "Vælg en kategori",
  "home.dropdownPlaceholder": "Vælg en kategori…",

  "home.valueTitle": "Alt, hvad du behøver for at researche AllChinaBuy-produkter",
  "home.valueSubtitle": "Seks fokuserede områder, der fører dig fra browsing til trygt køb.",
  "home.value1Title": "Spreadsheet",
  "home.value1Desc": "Organiserede produkt- og sælgerressourcer i ét hub.",
  "home.value2Title": "Pålidelige sælgere",
  "home.value2Desc": "Undersøg sælgere og sammenlign oplysninger, før du køber.",
  "home.value3Title": "QC-ressourcer",
  "home.value3Desc": "Forstå kvalitetskontrol-billeder og advarselstegn.",
  "home.value4Title": "Forsendelsesguider",
  "home.value4Desc": "Lær om metoder, omkostninger og vigtige overvejelser.",
  "home.value5Title": "Lagerguide",
  "home.value5Desc": "Forstå opbevaring, inspektion og forsendelsesflow.",
  "home.value6Title": "Købsguider",
  "home.value6Desc": "Trin-for-trin-ressourcer til alle niveauer.",

  "home.trustTitle": "Bygget til bedre AllChinaBuy-research",
  "home.trustCopy": "At finde produkter er let. At finde nyttige oplysninger, før du køber, er sværere. Vores mål er at organisere spredte AllChinaBuy-ressourcer i klare sider, praktiske guider og sikkerhedsinformation, så du kan researche med større tryghed.",
  "home.trust1Title": "Organiseret",
  "home.trust1Desc": "Ressourcer grupperet efter kategori og hensigt.",
  "home.trust2Title": "Gennemsigtigt",
  "home.trust2Desc": "Oplysninger verificeret og tydeligt dateret, hvor muligt.",
  "home.trust3Title": "Praktisk",
  "home.trust3Desc": "Guider fokuseret på de beslutninger, du faktisk skal træffe.",

  "home.articleTitle": "Fra ressourcehubbet",
  "home.articleSubtitle": "Læs vores dybdegående guide for at få mest muligt ud af AllChinaBuy-regnearket.",
  "home.articleCardTitle": "AllChinaBuy Spreadsheet: Den komplette guide",
  "home.articleExcerpt": "Lær, hvad regnearket er, hvordan du bruger det trin for trin, undersøger sælgere, tjekker QC-billeder og planlægger forsendelse — med praktiske tips og en sammenligningstabel.",
  "home.articleReadMore": "Læs hele guiden",
  "home.articleMeta": "Uafhængig guide · Opdateres jævnligt",
  "home.articlesTitle": "Seneste guider og ressourcer",
  "home.articlesSubtitle": "Udforsk vores dybdegående hovedguider om regnearket, sælgere, QC, forsendelse, lageret og meget mere.",
  "home.readNow": "Læs nu",
  "home.relatedGuides": "Relaterede guider",
  "home.articleNotFound": "Guide ikke fundet",

  "home.faqTitle": "Ofte stillede spørgsmål",
  "home.faqSubtitle": "Hurtige svar på de spørgsmål, vi oftest hører.",
  "home.faq1Q": "Hvad er AllChinaBuy-regnearket?",
  "home.faq1A": "Det er en organiseret samling af produktlinks, kategorinoter og købsressourcer, der hjælper dig med at researche produkter og sælgere, før du køber.",
  "home.faq2Q": "Er AllChinaBuy-regnearket gratis at bruge?",
  "home.faq2A": "Ja. Regnearket og dette ressourcehub er gratis at gennemse, og du behøver ikke betale noget for at se kategorierne og linkene.",
  "home.faq3Q": "Hvordan finder jeg pålidelige sælgere?",
  "home.faq3A": "Led efter klare produktbilleder, en ensartet annoncehistorik og anmeldelser, der nævner den faktiske vare. Krydstjek sælgere og gennemgå QC-billeder, før du beslutter dig.",
  "home.faq4Q": "Hvad er QC-billeder?",
  "home.faq4A": "QC-billeder (kvalitetskontrol) viser din faktiske vare, før den sendes. De hjælper dig med at opdage fejl, forkerte farver eller størrelsesproblemer, før varen forlader lageret.",
  "home.faq5Q": "Hvordan fungerer forsendelse?",
  "home.faq5A": "International forsendelse beregnes normalt efter vægt eller størrelse. Hurtigere metoder koster mere, mens økonomilinjer er billigere men langsommere. Planlæg forsendelsen tidligt for at forstå den samlede pris.",
  "home.faq6Q": "Er dette det officielle AllChinaBuy-websted?",
  "home.faq6A": "Nej. Dette er en uafhængig informationsressource og ikke det officielle AllChinaBuy-websted. Verificer altid vigtige detaljer direkte, før du køber.",

  "home.ctaTitle": "Klar til at udforske flere AllChinaBuy-ressourcer?",
  "home.ctaCopy": "Start med regnearket, sammenlign dine muligheder, lær hvordan QC og forsendelse fungerer, og udforsk de seneste købsressourcer.",
  "home.ctaPrimary": "Udforsk AllChinaBuy-regnearket",
  "home.ctaSecondary": "Læs købsguiderne",
};